import type { IconProps } from '.';

/**
 * Plus Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const PlusIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path d="M12.5 11.5V4H11.5V11.5H4V12.5H11.5V20H12.5V12.5H20V11.5H12.5Z" fill="white" />
  </svg>
);

export default PlusIcon;
